import { render } from "./LeaveAllowancePolicy.vue?vue&type=template&id=82abb8a0"
import script from "./LeaveAllowancePolicy.vue?vue&type=script&lang=js"
export * from "./LeaveAllowancePolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__